import React from 'react';
import { StarIcon, MessageSquareIcon, DownloadIcon, CheckCircleIcon } from 'lucide-react';
const Testimonials = () => {
  return <section className="w-full bg-white py-16" data-id="element-277">
      <div className="container mx-auto px-4" data-id="element-278">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#8B4513] mb-6" data-id="element-279">
          💬 Lo que dicen quienes ya se atrevieron
        </h2>
        <div className="flex justify-center mb-12" data-id="element-280">
          <div className="flex items-center" data-id="element-281">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" data-id="element-282" />)}
          </div>
          <p className="ml-2 font-bold" data-id="element-283">+1,893 reseñas reales</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-284">
          <div className="bg-[#F5EBE0] p-6 rounded-lg shadow-md" data-id="element-285">
            <div className="flex mb-4" data-id="element-286">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#FFD700] text-[#FFD700]" data-id="element-287" />)}
            </div>
            <p className="text-[#5E4B3C] mb-4 italic" data-id="element-288">
              "Mis invitados no dejaron nada. Fue como magia. Nunca había
              recibido tantos cumplidos por mi comida."
            </p>
            <div className="flex items-center" data-id="element-289">
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Karla P." className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-290" />
              <div data-id="element-291">
                <p className="font-bold text-[#8B4513]" data-id="element-292">Karla P.</p>
                <p className="text-sm text-[#A67C52]" data-id="element-293">Cliente desde 2022</p>
              </div>
            </div>
          </div>
          <div className="bg-[#F5EBE0] p-6 rounded-lg shadow-md" data-id="element-294">
            <div className="flex mb-4" data-id="element-295">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#FFD700] text-[#FFD700]" data-id="element-296" />)}
            </div>
            <p className="text-[#5E4B3C] mb-4 italic" data-id="element-297">
              "Hoy vendo en mi barrio y duplico mis ingresos. Estas recetas no
              solo impresionan, también son rentables."
            </p>
            <div className="flex items-center" data-id="element-298">
              <img src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Laura T." className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-299" />
              <div data-id="element-300">
                <p className="font-bold text-[#8B4513]" data-id="element-301">Laura T.</p>
                <p className="text-sm text-[#A67C52]" data-id="element-302">Cliente desde 2023</p>
              </div>
            </div>
          </div>
          <div className="bg-[#F5EBE0] p-6 rounded-lg shadow-md" data-id="element-303">
            <div className="flex mb-4" data-id="element-304">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#FFD700] text-[#FFD700]" data-id="element-305" />)}
            </div>
            <p className="text-[#5E4B3C] mb-4 italic" data-id="element-306">
              "Nunca imaginé que podría hacer algo así. Me siento imparable. Mis
              amigos ahora me piden consejos a mí."
            </p>
            <div className="flex items-center" data-id="element-307">
              <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Sofía R." className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-308" />
              <div data-id="element-309">
                <p className="font-bold text-[#8B4513]" data-id="element-310">Sofía R.</p>
                <p className="text-sm text-[#A67C52]" data-id="element-311">Cliente desde 2023</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center flex-wrap md:flex-nowrap space-x-4 md:space-x-8 mt-12" data-id="element-312">
          <div className="flex flex-col items-center" data-id="element-313">
            <MessageSquareIcon className="w-8 h-8 text-[#E25822] mb-2" data-id="element-314" />
            <p className="text-3xl font-bold text-[#8B4513]" data-id="element-315">+1,893</p>
            <p className="text-[#5E4B3C]" data-id="element-316">Reseñas reales</p>
          </div>
          <div className="flex flex-col items-center" data-id="element-317">
            <DownloadIcon className="w-8 h-8 text-[#E25822] mb-2" data-id="element-318" />
            <p className="text-3xl font-bold text-[#8B4513]" data-id="element-319">+2,089</p>
            <p className="text-[#5E4B3C]" data-id="element-320">Descargas activas</p>
          </div>
          <div className="flex flex-col items-center" data-id="element-321">
            <CheckCircleIcon className="w-8 h-8 text-[#E25822] mb-2" data-id="element-322" />
            <p className="text-3xl font-bold text-[#8B4513]" data-id="element-323">97%</p>
            <p className="text-[#5E4B3C]" data-id="element-324">Tasa de éxito</p>
          </div>
        </div>
      </div>
    </section>;
};
export default Testimonials;